import GroupsIcon from "@mui/icons-material/Groups";

interface ITeamPositionIcon {
  color: string;
}

const TeamPositionIcon: React.FC<ITeamPositionIcon> = ({ color }) => {
  return <GroupsIcon sx={{ color }} />;
};

export default TeamPositionIcon;
